export default __webpack_public_path__ + "static/1645-c8a6006bcaa2793fbe9b8edb06d918a1.gif";